import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/(app-view)/privacy-policy/_client-page.tsx");
